<template>
  <div :id="adId" />
</template>

<script lang="ts">
import Vue from 'vue';
import type {} from 'doubleclick-gpt';

type WindowWithGoogleTag = Window & typeof globalThis & {
  googletag?: googletag.Googletag;
}

const w: WindowWithGoogleTag = window;
const googletag = w.googletag;

export default Vue.extend({
  props: {
    adId: {
      type: String,
      required: true,
    },
    adUnitPath: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      adSlot: null as (googletag.Slot | null),
    };
  },

  mounted(): void {
    if (!googletag) return;

    const { adId, adUnitPath } = this;
    const el = this.$el as HTMLDivElement;

    const adWidth = parseInt(el.style.width, 10);
    const adHeight = parseInt(el.style.height, 10);

    googletag.cmd.push(() => {
      this.adSlot = googletag.defineSlot(adUnitPath, [adWidth, adHeight], adId);
      this.adSlot.addService(googletag.pubads());
      googletag.enableServices();

      googletag.display(this.adId);
    });
  },

  beforeDestroy(): void {
    if (!googletag) return;

    if (!this.adSlot) return;

    googletag.destroySlots([this.adSlot]);
  },
});
</script>
